export const userInfoSelector = (state: any) => state.userReducer.userInfo;